import { ReleaseNoteDto } from '@generated/backend-api/model/release-note-dto';
import {
  Component,
  effect,
  inject,
  signal,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CustomModalComponent } from '@components/custom-modal/custom-modal.component';
import { Router } from '@angular/router';
import { ReleaseNoteService } from '@services/release-notes/release-note.service';
import { ButtonDirective, CardFooterComponent } from '@ndwnu/design-system';
import { ContainsModal } from '@services/custom-modal/custom-modal.service';

@Component({
  selector: 'app-release-notes-popup',
  templateUrl: './release-notes-popup.component.html',
  styleUrls: ['./release-notes-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CustomModalComponent, CardFooterComponent, ButtonDirective],
})
export class ReleaseNotesPopupComponent implements ContainsModal {
  readonly popupReleaseNote = signal<ReleaseNoteDto | undefined>(undefined);
  readonly modalRef = viewChild.required<CustomModalComponent>('modalRef');
  private readonly releaseNoteService = inject(ReleaseNoteService);
  private readonly router = inject(Router);

  constructor() {
    effect(() => {
      if (this.releaseNoteService.unreadLarge().length > 0) {
        this.popupReleaseNote.set(this.releaseNoteService.unreadLarge()[0]);
        this.modalRef().open();
      }
    });
  }

  completeReleaseNote(): void {
    this.router.navigate(['/updates']).then((): void => {
      this.closeReleaseNoteModal();
    });
  }

  closeReleaseNoteModal(): void {
    let releaseNote = this.popupReleaseNote();
    if (releaseNote) {
      this.releaseNoteService.markAsRead([releaseNote]);
    }
    this.modalRef().close();
  }
}
